// EK-02 / EK-03: shared by User Onboarding (list column, bulk decisions) and the DARE section of
// User Onboarding Details (approval, history, billing). DARE Approvals used to be its own page.

// Same codes as the Ecosystem Integrator console's DARE rejection reasons.
export const REJECTION_REASONS = [
  { value: 'INCOMPLETE_INFORMATION', label: 'Incomplete or missing information' },
  { value: 'DUPLICATE_APPLICATION', label: 'Duplicate application' },
  { value: 'INELIGIBLE_LOCATION', label: 'Outside service area' },
  { value: 'UNVERIFIED_IDENTITY', label: 'Identity could not be verified' },
  { value: 'OTHER', label: 'Other' },
];

export const APPROVAL_STATUS_CHIP = {
  PENDING: { label: 'Pending', bg: '#FFF4E5', color: '#8A5300' },
  APPROVED: { label: 'Approved', bg: '#E6F4EA', color: '#1B5E20' },
  REJECTED: { label: 'Rejected', bg: '#FDECEA', color: '#B3261E' },
};

export const ACTION_LABEL = {
  REQUESTED: 'Signed up',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  REOPENED: 'Re-opened',
};

export const ROLE_LABEL = {
  EKUTIR: 'eKutir',
  ECOSYSTEM_INTEGRATOR: 'Ecosystem Integrator',
  AUTO: 'Automatic (before approvals)',
};

export const SUBSCRIPTION_STATUS = {
  PENDING_PAYMENT: { label: 'Waiting for payment', bg: '#FFF4E5', color: '#8A5300' },
  ACTIVE: { label: 'Active', bg: '#E6F4EA', color: '#1B5E20' },
  OVERDUE: { label: 'Overdue', bg: '#FFF4E5', color: '#8A5300' },
  EXPIRED: { label: 'Expired', bg: '#FDECEA', color: '#B3261E' },
  CANCELLED: { label: 'Cancelled', bg: '#F1F1F1', color: '#1C1B1F' },
};

export const MANUAL_METHODS = ['CASH', 'BANK_TRANSFER'];

export const reasonLabel = (code) => REJECTION_REASONS.find((reason) => reason.value === code)?.label || code;

export const approverLabel = (approval) =>
  approval?.approverType === 'EKUTIR' ? 'eKutir' : approval?.ecosystemName || 'Ecosystem Integrator';

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString();
};

export const formatDay = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '-' : date.toLocaleDateString();
};

/** True when eKutir (not an integrator) decides this DARE's pending sign-up. */
export const isEkutirPending = (approval) => approval?.status === 'PENDING' && approval?.approverType === 'EKUTIR';
